import { AlertColor } from '@mui/material/Alert';
import { createContext } from 'react';

type SnackbarContextValue = (message: string, type?: AlertColor) => void;
type SnackbarContextDefault = () => void;

export const SnackbarContext = createContext<SnackbarContextValue | SnackbarContextDefault>(
  () => {}
);
